<script setup>
// V5-P1 · 2026-05-15 (Victor) · Menú AI estilo Kommo (icono + label)
// Mapping a operaciones backend disponibles:
//  - fix_spelling_grammar (corrige gramática)
//  - improve (mejora respuesta con contexto)
//  - tones: professional · casual · friendly · confident · straightforward
const emit = defineEmits(['executeCopilotAction']);

// Auto-corregir al pausar: ELIMINADO del menú (Victor 2026-06-09). La corrección
// ahora es solo manual con clic en los filtros de abajo; ya no hay autocorrección
// automática para nadie.

// Claves alineadas con el backend para que cada botón haga EXACTAMENTE lo que dice
// (Victor 2026-06-05 · consistencia): witty=ingenioso, make_longer=más largo, etc.
const actions = [
  { key: 'fix_spelling_grammar', label: 'Corregir gramática y ortografía', icon: '✎' },
  { key: 'professional',         label: 'Hacerlo profesional',             icon: '💼' },
  { key: 'friendly',             label: 'Hacerlo amistoso',                icon: '🙂' },
  { key: 'witty',                label: 'Hacerlo ingenioso',               icon: '😄' },
  { key: 'make_longer',          label: 'Hacerlo más largo',               icon: '📏' },
  { key: 'make_shorter',         label: 'Hacerlo más corto',               icon: '➖' },
  { key: 'straightforward',      label: 'Simplificarlo',                   icon: '✨' },
];

function handleClick(key) {
  emit('executeCopilotAction', key);
}
</script>

<template>
  <div
    class="absolute bottom-full mb-2 right-0 z-50 min-w-72 rounded-xl border border-n-weak bg-n-background shadow-lg p-2"
  >
    <div class="px-3 py-1.5 text-[10px] font-bold tracking-wider uppercase text-n-slate-11 flex items-center gap-1.5">
      Victor AI <span class="px-1.5 py-0.5 rounded text-[9px] bg-amber-500/15 text-amber-500 font-bold">Beta</span>
    </div>
    <button
      v-for="action in actions"
      :key="action.key"
      class="w-full flex items-center gap-3 px-3 py-2.5 text-sm text-n-slate-12 rounded-lg hover:bg-n-alpha-2 cursor-pointer"
      @click="handleClick(action.key)"
    >
      <span class="w-5 text-center text-base">{{ action.icon }}</span>
      <span class="flex-1 text-left">{{ action.label }}</span>
    </button>
  </div>
</template>
